import PropTypes from 'prop-types';

export const DISCOVER = 'discover';
export const SEARCH = 'search';
export const propType = PropTypes.oneOf([DISCOVER, SEARCH]);
